import { Component, OnInit, Inject, ViewChild, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { addImageFields, InternalFields, ExternalFields, ImageFields } from './add-image-model';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';
import { SpecimenPreviewService } from './../../../../../service/specimen-preview.service';

@Component({
	selector: 'app-add-image-dailog',
	templateUrl: './add-image-dailog.component.html',
	styleUrls: ['./add-image-dailog.component.scss']
})
export class AddImageDailogComponent implements OnInit {

	public addImageForm: addImageFields = new addImageFields();
	public exImageType: Array<object> = [];
	public exCategory: Array<object> = [];
	public exImageSubType: Array<object> = [];
	public inMagnification: Array<object> = [];
	public saveButtonFields: ImageFields = new ImageFields();
	public uploadedFile: File;

	@ViewChild('lightbox') lightbox;
	public lightBoxImagePath: any;

	constructor(
		private ptImageMappingService: PtImageMappingService,
		private specimenPreviewService: SpecimenPreviewService,
		public dialogRef: MatDialogRef<AddImageDailogComponent>,
		private renderer: Renderer2,
		@Inject(MAT_DIALOG_DATA) public dailogData:any)
	{
		// ASSIGN ADD IMAGE FORM.
		this.addImageForm.internal = new InternalFields();
		this.addImageForm.external = new ExternalFields();
		this.addImageForm.isEdit = (this.dailogData.is_edit) ? true : false;
		this.addImageForm.external.thumbnail = (this.addImageForm.isEdit && this.dailogData.thumbnailView == 'Y') ? true : false;
		this.addImageForm.disableBtn = (this.dailogData.is_edit) ? false : true;
		this.addImageForm.specimenYear = localStorage.getItem('specimen-year');

		if(this.addImageForm.isEdit && this.addImageForm.external.thumbnail){
			this.getThumbnailImage();
		}
	}

	ngOnInit(): void {
		this.addImageForm.specimenCode = (this.dailogData && this.dailogData.specimenCode) ? this.dailogData.specimenCode : "";
		// TO GET THE IMAGE TYPES LIST.
		this.getImageType();

		// TO GET THE MEGINIFICATION LIST.
		this.getMegnification();
		if (!this.addImageForm.isEdit){
			this.getMegnificationSequ();
		}else{
			this.addImageForm.internal.image_id = this.dailogData.id;
			this.addImageForm.internal.magnification = (this.dailogData.magnification && this.dailogData.magnification != "All") ? this.dailogData.magnification : '';
			this.addImageForm.internal.squence = this.dailogData.sequence;
			this.addImageForm.internal.comment = this.dailogData.extComment;

			this.addImageForm.external.imagetype = this.dailogData.typeCode;
			this.addImageForm.external.imagename = this.dailogData.externalName;
			this.addImageForm.external.group = this.dailogData.group;
			if(this.dailogData.typeCode != null && this.dailogData.typeCode != ''){
				this.ptImageMappingService.getCategory(this.dailogData.typeCode).subscribe( (result:Array<object>) => {
					this.exCategory = result;
					const category:any = this.exCategory.find( (item:any) => item.slideTypeCode == this.dailogData.category);
					if(category != undefined){
						this.addImageForm.external.category = category.slideTypeCode;
						this.ptImageMappingService.getImageSubType(category.slideTypeCode).subscribe( (iresult:Array<object>) => {
							this.exImageSubType = iresult;
							this.addImageForm.external.imagesubtype = this.dailogData.subTypeCode;
						});
					}
				});
			}
		}
	}

	// API SERVER CALL TO GET THE IMAGE TYPE.
	getImageType = () => {
		this.ptImageMappingService.getImageType().subscribe( (result: Array<object>) => {
			this.exImageType = result;
		});
	}

	// API SERVER CALL TO GET THE MEGINIFICATION.
	getMegnification = () => {
		this.ptImageMappingService.getMegnification().subscribe( (result: Array<object>) => {
			this.inMagnification = result;
		});
	}

	// TO CHECK THE MEGNIFICATION SEQUANCE #.
	getMegnificationSequ = () => {
		this.ptImageMappingService.getMegnificationSequ(this.dailogData.mailing, this.dailogData.specimenCode).subscribe( (result: number) => {
			this.addImageForm.internal.squence = result;
		});
	}

	// TO CHECK THE LENGHT ON KEY UP.
	onKeyUpLength = (event, fieldType, field, limit) => {
		this.addImageForm[fieldType][field] = (event.target.value.length <= limit) ? event.target.value : event.target.value.substring(0, limit);
	}

	// TO CHECK THE SEQUANCE NO ON KEY UP EVENT.
	onKeyUpValidate = event => {
		if(this.dailogData.is_edit){
			this.addImageForm.disableBtn = (this.addImageForm.internal.squence) ? false : true;
		}else{
			this.addImageForm.disableBtn = (this.addImageForm.internal.squence && this.addImageForm.uploadImage) ? false : true;
		}
	}

	// CLICK ON UPLOAD IMAGE BUTTON TO SET THE IMAGE .
	onChangeUploadImage = (event) => {
		if(event.target.files && event.target.files[0]){
			this.uploadedFile = event.target.files[0];
			this.addImageForm.uploadImage = event.target.files[0].name;
			if(this.dailogData.is_edit){
				this.addImageForm.disableBtn = (this.addImageForm.internal.squence) ? false : true;
			}else{
				this.addImageForm.disableBtn = (this.addImageForm.internal.squence && this.addImageForm.uploadImage) ? false : true;
			}

			const reader = new FileReader();
			const [image] = event.target.files;
			reader.readAsDataURL(image);

			reader.onload = () => {
				this.addImageForm.thumbnailURL = reader.result as string;
			};
		}
	}

	// ON CLICK TO UPLOADED IMAGE DELETE BUTTON.
	onClickRemoveImage = () => {
		this.addImageForm.uploadImage = null;
		this.addImageForm.disableBtn = true;
		this.addImageForm.thumbnailURL = null;
		this.addImageForm.external.thumbnail = false;
	}

	// ON CHANGE IMAGE TYPE TO GET CATEGORY.
	onChangeImageType = event => {
		this.addImageForm.external.category = "";
		this.addImageForm.external.imagesubtype = "";
		if(event.target.value !== ""){
			const imageObj:any = this.exImageType.find( (item:any) => item.slideTypeCode == event.target.value);
			this.saveButtonFields.typeDesc = imageObj.description;

			this.ptImageMappingService.getCategory(event.target.value).subscribe( (result:Array<object>) => {
				this.exCategory = result;
			});
		}else{
			this.saveButtonFields.typeDesc = '';
			this.exCategory = [];
			this.exImageSubType = [];
		}
	}

	// ON CAHGNE CATEGORY TO GET IMAGE SUB TYPE.
	onChangeCategory = event => {
		this.addImageForm.external.imagesubtype = "";
		if(event.target.value !== ""){
			this.ptImageMappingService.getImageSubType(event.target.value).subscribe( (result:Array<object>) => {
				this.exImageSubType = result;
			});
		}else{
			this.exImageSubType = [];
		}
	}

	// ON CHANGE IMAGE SUB TYPE TO SET THE SAVE FORM FIELS "SUB TYPE DESC"
	onChangeImageSubType = event => {
		if(event.target.value !== ""){
			const imageObj:any = this.exImageSubType.find( (item:any) => item.slideTypeCode == event.target.value);
			this.saveButtonFields.subTypeDesc = imageObj.description;
		}else{
			this.saveButtonFields.subTypeDesc = '';
		}
	}

	// ON IMAGE CLICK TO GET THE SERVER CALL AND SET THE THUMBNAIL URL.
	getThumbnailImage = () => {
		const year = localStorage.getItem('specimen-year');
		const ext = this.dailogData.name.split('.');
		if (ext[1] !== 'zip' || ext[1] !== 'htm' || ext[1] !== 'html') {
			const URL = 'PTImages/' + year + '/t_' + this.dailogData.imageNumber + '.' + ext[1];
			this.specimenPreviewService.getImageS3Url(URL).subscribe(res => {
				this.addImageForm.thumbnailURL = res;
			});
		}
	}

	// ON CLICK TO SAVE DATA TO DATABASE.
	onClickSave = () => {
		this.saveButtonFields.specimenCode = this.addImageForm.specimenCode;
		this.saveButtonFields.fullPath = this.addImageForm.uploadImage;
		this.saveButtonFields.name = this.addImageForm.uploadImage;
		this.saveButtonFields.id = this.addImageForm.internal.image_id;
		this.saveButtonFields.magnification = this.addImageForm.internal.magnification;
		this.saveButtonFields.comment =this.addImageForm.internal.comment;
		this.saveButtonFields.subTypeCode = this.addImageForm.external.imagesubtype;
		this.saveButtonFields.sequence = this.addImageForm.internal.squence;
		this.saveButtonFields.externalName = this.addImageForm.external.imagename;
		this.saveButtonFields.approveFlag = this.dailogData.approveFlag;
		this.saveButtonFields.group = this.addImageForm.external.group;
		this.saveButtonFields.thumbnailView = (this.addImageForm.external.thumbnail) ? 'Y' : 'N';
		this.saveButtonFields.extComment = this.addImageForm.internal.comment;
		this.saveButtonFields.specLink = this.dailogData.specLink;
		this.saveButtonFields.spec = this.dailogData.spec;
		this.saveButtonFields.imageNumber = this.dailogData.imageNumber;
		this.saveButtonFields.lastUpdated = this.dailogData.lastUpdated;
		this.saveButtonFields.lastUpdatedUser = this.dailogData.lastUpdatedUser;
		this.saveButtonFields.logInfo = this.dailogData.logInfo;
		this.saveButtonFields.diagnosis = this.dailogData.diagnosis;
		this.saveButtonFields.diagnosisDesc = this.dailogData.diagnosisDesc;
		this.saveButtonFields.actionDiagnosis = this.dailogData.actionDiagnosis;
		this.saveButtonFields.diagnosisMenu = this.dailogData.diagnosisMenu;
		this.saveButtonFields.typeCode = this.addImageForm.external.imagetype;
		this.saveButtonFields.mailing  = this.dailogData.mailing;
		this.saveButtonFields.mailingYear = this.addImageForm.specimenYear;

		const url = (this.addImageForm.isEdit === false) ? 'addImage' : 'updateImage';

		// SERVER CALL TO SAVE THE DATA.
		this.ptImageMappingService.saveUpdateApproveImage(this.saveButtonFields, url).subscribe( result => {
			if(this.addImageForm.isEdit === false){
				this.ptImageMappingService.uploadImageToS3(result.preSignedUrlForImageUpload, this.uploadedFile).subscribe( uploadResult => {
					let dailogReturnData = result;
					dailogReturnData.specimenCode = this.saveButtonFields.specimenCode;
					dailogReturnData.mailing = this.saveButtonFields.mailing;
					dailogReturnData.name = this.saveButtonFields.name;
					dailogReturnData.code = (this.dailogData.specimenCode !== '') ? this.dailogData.specimenCode : this.dailogData.mailingID;
					this.dialogRef.close(dailogReturnData);
				});
				this.ptImageMappingService.uploadImageToS3(result.preSignedUrlForThumbnailImage, this.uploadedFile).subscribe( thumbnailResult => {
					// THIS IS INTENTIONAL
				});
			}else{
				let dailogReturnData = {
					specimenCode : this.addImageForm.specimenCode,
					mailing : this.dailogData.mailing,
					name : this.addImageForm.uploadImage
				};
				this.dialogRef.close(dailogReturnData);
			}
		});
	}

	// ON CLICK UPLOADED TO VIEW.
	onClickViewImage = () => {
		this.renderer.addClass(this.lightbox.nativeElement, 'open');
		this.renderer.addClass(document.body, 'lightbox-open');
	}

	// CLOSE LIGHT BOXS
	closeImageLightbox() {
		this.renderer.removeClass(this.lightbox.nativeElement, 'open');
		this.renderer.removeClass(document.body, 'lightbox-open');
	}
}